module.exports = __webpack_public_path__ + "img/icon1-选中.f676ff2a.png";